import * as React from 'react';
import { useCallback, useEffect, useRef } from 'react';

export interface LineStepsProps extends React.SVGProps<SVGSVGElement> {
  onPointsCalculated: (points: ButtonPointsProps[]) => void;
}

export interface ButtonPointsProps {
  x: number;
  y: number;
}

const Line2Steps: React.FC<LineStepsProps> = ({
  onPointsCalculated,
  ...props
}) => {
  const svgRef = useRef<SVGSVGElement>(null);
  const point1 = useRef<SVGCircleElement>(null);
  const point2 = useRef<SVGCircleElement>(null);

  const handlePointsCalculated = useCallback(() => {
    if (point1.current && point2.current && svgRef.current) {
      const points = [point1.current, point2.current];
      const newPositionPoints: ButtonPointsProps[] = [];
      const svgRect = svgRef.current.getBoundingClientRect();

      points.forEach(point => {
        if (!point.ownerSVGElement) {
          return;
        }

        const svgPoint = point.ownerSVGElement.createSVGPoint();
        svgPoint.x = point.cx.baseVal.value;
        svgPoint.y = point.cy.baseVal.value;
        const ctm = point.getScreenCTM();

        if (!ctm) {
          return;
        }
        const transformedPoint = svgPoint.matrixTransform(ctm);

        // Calcular posição relativa ao container do SVG
        newPositionPoints.push({
          x: transformedPoint.x - svgRect.left,
          y: transformedPoint.y - svgRect.top,
        });
      });

      onPointsCalculated(newPositionPoints);
    }
  }, [onPointsCalculated]);

  useEffect(() => {
    handlePointsCalculated();
    window.addEventListener('resize', handlePointsCalculated);

    if (svgRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        handlePointsCalculated();
      });
      resizeObserver.observe(svgRef.current);
      return () => {
        resizeObserver.disconnect();
        window.removeEventListener('resize', handlePointsCalculated);
      };
    }

    return () => {
      window.removeEventListener('resize', handlePointsCalculated);
    };
  }, [handlePointsCalculated]);

  return (
    <svg
      ref={svgRef}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 383 142"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <path
        fill="#1E88E5"
        d="M313.082 142c-38.554 0-69.909-31.249-69.909-69.648v-2.694c0-28.386-23.186-51.485-51.678-51.485-28.492 0-51.678 23.09-51.678 51.486v2.014c0 38.41-31.365 69.649-69.909 69.649C31.366 141.322 0 110.073 0 71.673V68.98l18.23-.01v2.693c0 28.386 23.186 51.486 51.678 51.486 28.492 0 51.679-23.1 51.679-51.486V69.65C121.587 31.239 152.952 0 191.495 0c38.543 0 69.909 31.249 69.909 69.648v2.694c0 28.386 23.186 51.485 51.678 51.485 28.492 0 51.678-23.099 51.678-51.486H383c0 38.41-31.365 69.649-69.908 69.649l-.01.01Z"
      />
      <circle
        ref={point1}
        cx={69}
        cy={69.5}
        r={1.061}
        style={{ fillOpacity: 0 }}
      />
      <circle
        ref={point2}
        cx={314}
        cy={72}
        r={1.061}
        style={{ fillOpacity: 0 }}
      />
    </svg>
  );
};
export default Line2Steps;
